<template>
  <div class="container">
    <div class="content">
      <div class="content-left">
        <div class="content-left-top">
          <div class="content-left-top-in">
            <el-form
              :model="searchInfo"
              label-width="65px"
              label-position="right"
              @submit.native.prevent
            >
              <el-form-item label="授课教师: ">
                <common-staff-pull-down
                  :originId.sync="searchInfo.teacher_id"
                  :defaultSelected.sync="searchInfo.teacher_list"
                  :jobIds="[1]"
                  @change="handleTeacherChange"
                ></common-staff-pull-down>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="content-left-center">
          <div class="content-left-center-left" v-if="teacherInfo.teacher">
            <img
              :src="teacherInfo.teacher.avatar"
              alt=""
              style="width: 50px; height: 50px"
            />
          </div>
          <div class="content-left-center-left" v-else></div>
          <div class="content-left-center-right">
            <div class="content-name">
              {{ teacherInfo.teacher ? teacherInfo.teacher.name : "-" }}
            </div>
            <div class="content-phone">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/teacher/phone.png"
                style="margin-right: 10px"
                alt=""
              />
              <span>{{
                teacherInfo.teacher ? teacherInfo.teacher.mobile : "-"
              }}</span>
            </div>
          </div>
        </div>
        <div class="xian"></div>
        <div class="teacher-detial">
          <div class="left-info">
            <div class="p1">
              <p class="left-info-title">本周数据：</p>
              <p class="mwow-gray">
                {{
                  `${startWeekTime.slice(5, 10)} ~ ${endWeekTime.slice(5, 10)}`
                }}
              </p>
            </div>
            <div class="content-teacher-info">
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('rollCallRecord', 'week', '3')"
              >
                <p class="class-info-name">点名课次：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.week.lesson_roll_call || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('rollCallRecord', 'week', '4')"
              >
                <p class="class-info-name">点名学员：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.week.roll_call_student || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('afterClass', 'week', '1')"
              >
                <p class="class-info-name">发布练习：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.week.homework || "-" }}
                </p>
              </div>
            </div>
          </div>
          <div class="left-info">
            <div class="p1">
              <p class="left-info-title">本月数据：</p>
              <p class="mwow-gray">{{ startMonthTime.slice(0, 7) }}</p>
            </div>
            <div class="content-teacher-info">
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('rollCallRecord', 'month', '3')"
              >
                <p class="class-info-name">点名课次：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.month.lesson_roll_call || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('rollCallRecord', 'month', '4')"
              >
                <p class="class-info-name">点名学员：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.month.roll_call_student || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('afterClass', 'month', '1')"
              >
                <p class="class-info-name">发布练习：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.month.homework || "-" }}
                </p>
              </div>
            </div>
          </div>
          <div class="left-info">
            <div class="p1">
              <p
                class="left-info-title"
                style="display: flex; align-items: center"
              >
                全部数据：
                <span>
                  <el-popover
                    placement="top"
                    width="200"
                    popper-class="followuppopover"
                    trigger="hover"
                  >
                    <p class="tipck">
                      1vN班级：现有未结业班级；<br />
                      1vN未满班级：未结业班级中没有满班班级；<br />
                      1v1班级：现有未结业班级；<br />
                      点名课次：教师已完成点名的课次数；<br />
                      点名学员：教师已完成点名的学员数；<br />
                      发布练习：教师已发布的练习数；
                    </p>
                    <div class="question" slot="reference">
                      <div>?</div>
                    </div>
                  </el-popover>
                </span>
              </p>
              <p class="mwow-gray">{{ "至今" }}</p>
            </div>
            <div class="content-teacher-info">
              <div class="teacher-info-class" @click="Jumps('classManage')">
                <p class="class-info-name">1vN班级：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.one_to_many_class || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="Jumps('classManage', '2')"
              >
                <p class="class-info-name">1vN未满班级：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.one_to_many_not_full_class || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="Jumps('classManage', '1')"
              >
                <p class="class-info-name">1v1班级：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.one_on_one_class || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('rollCallRecord', 'all', '3')"
              >
                <p class="class-info-name">点名课次：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.lesson_roll_call || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('rollCallRecord', 'all', '4')"
              >
                <p class="class-info-name">点名学员：</p>
                <p class="mwow-green class-info-number">
                  {{ teacherInfo.roll_call_student || "-" }}
                </p>
              </div>
              <div
                class="teacher-info-class"
                @click="goRollCallStudent('afterClass', 'all')"
              >
                <p class="class-info-name">发布练习：</p>
                <p class="mwow-green class-info-number last-info">
                  {{ teacherInfo.homework || "-" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <el-form size="mini" :model="searchInfo" inline ref="form">
          <el-row>
            <el-col :span="8">
              <el-form-item label="学员搜索 :" prop="student_key_word">
                <el-input
                  v-model="searchInfo.student_key_word"
                  placeholder="学员姓名/手机号"
                  @change="handleSearch"
                  clearable
                  @clear="handleSearch"
                  prefix-icon="el-icon-search"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="课程名称 :" prop="current_status">
                <el-select
                  v-model="searchInfo.course_id"
                  placeholder="请选择"
                  @change="handleSearch"
                  @focus="getCourseList('')"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in courseList"
                    :key="item.course_id"
                    :label="item.title"
                    :value="item.course_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="停课状态 :" prop="stop_type">
                <el-select
                  v-model="searchInfo.stop_type"
                  placeholder="请选择"
                  @change="handleSearch"
                  clearable
                  multiple
                >
                  <el-option
                    v-for="item in suspendClassList"
                    :key="item.suspendClass_id"
                    :label="item.title"
                    :value="item.suspendClass_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="入学时间 :" prop="admin_time">
                <common-date-range-selector
                  v-model="searchInfo.admin_time"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleSearch"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科目:" prop="subject_ids">
                <el-select
                  v-model="searchInfo.subject_ids"
                  placeholder="请选择"
                  @change="handleSearch"
                  @focus="getSubjectList"
                  clearable
                  multiple
                >
                  <el-option
                    v-for="item in subjectsList"
                    :key="item.subject_id"
                    :label="item.subject_title"
                    :value="item.subject_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学员状态 :" prop="student_status">
                <el-radio-group
                  v-model="searchInfo.student_status"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">意向</el-radio-button>
                  <el-radio-button :label="2">在读</el-radio-button>
                  <el-radio-button :label="3">历史</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="授课状态 :" prop="teach_status">
                <el-radio-group
                  v-model="searchInfo.teach_status"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">授课中</el-radio-button>
                  <el-radio-button :label="2">已流失</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="课程类型:" prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">1vN</el-radio-button>
                  <el-radio-button :label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="statistics">
          授课中学员 {{ classTotal.in_class_total || "0" }}人、 已流失学员
          {{ classTotal.loss_class_total || "0" }}人、 停课课程
          {{ classTotal.stop_course_total || "0" }}个
          <div style="cursor: default">
            <el-popover
              placement="top"
              width="220"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">手动关联：手动添加关联、手动解除关联;</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </div>
        <!-- 注释：v2.63.x 去掉关联学员入口 -->
        <!-- <associate-students
          :t_id="searchInfo.teacher_id"
          @change="relationSuccess"
        >
          <div>
            <el-button class="mwow-button-filled success">关联学员</el-button>
          </div>
        </associate-students> -->
        <el-table
          size="mini"
          v-horizontal-scroll
          :data="tableData"
          stripe
          style="width: 100%"
          @sort-change="clickSort"
          :default-sort="{ prop: 'admission_time', order: 'descending' }"
        >
          <el-table-column label="学员姓名" prop="student.name">
            <template slot-scope="scope">
              <div
                class="mwow-green curp"
                @click="goStudentDetail(scope.row.student.student_id)"
              >
                {{ scope.row.student.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="学员状态" prop="status">
            <template slot-scope="scope">
              <div v-if="scope.row.student.status === 1">意向</div>
              <div v-if="scope.row.student.status === 2">在读</div>
              <div v-if="scope.row.student.status === 3">历史</div>
            </template>
          </el-table-column>
          <el-table-column label="课程名称" prop="course.detail">
            <template slot-scope="scope">
              <div v-if="scope.row.course.detail !== null">
                <div>
                  {{ scope.row.course.detail.title }}
                  <span
                    class="mwow-red"
                    v-show="scope.row.course.is_stop"
                    style="margin-left: 5px"
                    >停课中</span
                  >
                </div>
                <p class="mwow-red" v-if="scope.row.course.stop_end_time !== 0">
                  (
                  {{
                    getTime(
                      new Date(Number(scope.row.course.stop_end_time + "000")),
                      2
                    ) + " 复课"
                  }}
                  )
                </p>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column label="科目" prop="subject_title">
            <template slot-scope="scope">{{
              scope.row.subject.subject_title
            }}</template>
          </el-table-column>
          <el-table-column label="课程类型" prop="course_type" width="90">
            <template slot-scope="scope">{{
              scope.row.course.detail.course_type === 1 ? "1vN" : "1v1"
            }}</template>
          </el-table-column>
          <el-table-column label="手机号" prop="student.mobile">
            <template slot-scope="scope">
              {{ "+" + scope.row.student.area_code }}
              {{ scope.row.student.mobile }}
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="selfheader">
                <div>授课状态</div>
                <el-popover
                  placement="top"
                  width="200"
                  popper-class="followuppopover"
                  trigger="hover"
                >
                  <p class="tipck">
                    <!-- 授课中，学员添加至教师班级中，且教师完成点名; <br /> -->
                    授课中，学员与老师进行关联，处于关联状态; <br />
                    已流失，学员与当前教师解除关联；
                  </p>
                  <div class="question" slot="reference">
                    <div>?</div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row.grant_lesson_status === 1">授课中</div>
              <div v-if="scope.row.grant_lesson_status === 2">已流失</div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="selfheader">
                <div>已点名课次</div>
                <el-popover
                  placement="top"
                  width="200"
                  popper-class="followuppopover"
                  trigger="hover"
                >
                  <p class="tipck">学员与教师关联时，完成点名的课次</p>
                  <div class="question" slot="reference">
                    <div>?</div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                class="mwow-green curp"
                @click="
                  jumpRollCallStudent(
                    'rollCallRecord',
                    '4',
                    scope.row.student.name,
                    scope.row.course.detail.course_id
                  )
                "
              >
                {{ scope.row.roll_call_count }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上次点名时间" prop="last_roll_call_time">
            <template slot-scope="scope">
              {{
                scope.row.last_roll_call_time
                  ? getTime(
                      new Date(Number(scope.row.last_roll_call_time + "000")),
                      2
                    )
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="入学时间"
            prop="admission_time"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              {{
                getTime(new Date(Number(scope.row.admission_time + "000")), 2)
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="255">
            <template slot-scope="scope">
              <div class="operation">
                <teacher-and-student-detail
                  :rid="scope.row.relation_id"
                  :originData="detailInfo"
                  @change="handleDetailChange"
                >
                  <div
                    class="mwow-button success operation-first"
                    @click="handleClickDetail(scope.row)"
                  >
                    详情
                  </div>
                </teacher-and-student-detail>
                <relieve-associate
                  :student-info="scope.row"
                  @changeRelease="relationSuccess"
                  v-show="scope.row.grant_lesson_status === 1"
                >
                  <div class="mwow-button" style="margin-right: 5px">解绑</div>
                </relieve-associate>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { staffList, getSelectCourseList } from "@/api/globalSearch";
import teacherAndStudentDetail from "./teacherAndStudentDetail.vue";
import {
  relationStudentListApi,
  relationStudentStatisticsApi,
  relationStudentListStatisticsApi,
} from "@/api/teacherManage";
import {
  dateFormat,
  getCurrentWeek,
  getCurrentMonth,
} from "@/utils/timeFormat";
import { mixin } from "@/mixin/tabPageInfoMixin";
// import associateStudents from "./associateStudents.vue";
import relieveAssociate from "./relieveAssociate.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import { subjectList } from "@/api/subject";

export default {
  name: "teacherAndStudentInfo",
  props: ["visible"],
  components: {
    teacherAndStudentDetail,
    // associateStudents,
    relieveAssociate,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  mixins: [mixin],
  data() {
    return {
      searchInfo: {
        teacher_id: "",
        teacher_list: [],
        student_key_word: "",
        current_status: -1,
        teach_status: -1,
        roll_call_time: [],
        admin_time: [],
        sort_type: "desc",
        sort_field: "",
        course_id: "",
        student_status: -1,
        stop_type: [],
        course_type: -1,
      },
      teacherInfo: {
        week: {},
        month: {},
      },
      teacherName: "",
      teacherMobile: "",
      classTotal: {},
      tableData: [],
      dialogTableVisible: false,
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      courseList: [],
      startWeekTime: "", // 本周开始时间
      endWeekTime: "", // 本周结算时间
      startMonthTime: "", // 本月开始时间
      endMonthTime: "", // 本月结束时间
      detailInfo: {}, // 当前行的信息
      suspendClassList: [
        {
          suspendClass_id: 1,
          title: "正常",
        },
        {
          suspendClass_id: 2,
          title: "停课中",
        },
      ],
      subjectsList: [],
    };
  },
  created() {
    this.mixinGetPageInfo("teacherAndStudentInfo");
    this.startWeekTime = dateFormat("YYYY-mm-dd", getCurrentWeek()[0]);
    this.endWeekTime = dateFormat("YYYY-mm-dd", getCurrentWeek()[1]);
    this.startMonthTime = dateFormat(
      "YYYY-mm-dd",
      getCurrentMonth(new Date())[0]
    );
    this.endMonthTime = dateFormat(
      "YYYY-mm-dd",
      getCurrentMonth(new Date())[1]
    );
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      if (this.searchInfo.teacher_id) {
        this.handleTeacherChange();
      } else {
        this.handleSearchTeacher("");
      }
      if (this.searchInfo.course_id) {
        this.getCourseList("");
      }
      if (
        this.searchInfo.subject_ids &&
        this.searchInfo.subject_ids.length > 0
      ) {
        this.getSubjectList();
      }
    },
    getSubjectList() {
      if (this.subjectsList.length > 0) {
        return false;
      }
      subjectList({
        page: 1,
        page_size: 100,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectsList = [...res.data.list];
        }
      });
    },
    getCourseList(v) {
      if (this.courseList.length > 0) {
        return false;
      }
      getSelectCourseList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    handleSearchTeacher(v) {
      staffList({
        page: 1,
        page_size: 100,
        key_word: v,
        job_ids: [1],
        status: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.list && res.data.list[0]) {
            this.searchInfo.teacher_id = res.data.list[0].staff_id;
            this.handleTeacherChange();
          }
        }
      });
    },
    getTime(e, type) {
      if (type === 1) {
        const format = dateFormat("YYYY-mm-dd HH:MM", e);
        return format.slice(0, 10) + " " + format.slice(11);
      } else {
        const format = dateFormat("YYYY-mm-dd", e);
        return format.slice(0, 10);
      }
    },
    // search_type 页码和条目数不发起统计请求
    getList(params, search_type) {
      params = {
        page: this.page,
        page_size: this.pageSize,
        teacher_id: Number(this.searchInfo.teacher_id),
      };
      if (this.searchInfo.student_key_word) {
        params.student_key_word = this.searchInfo.student_key_word;
      }
      if (this.searchInfo.current_status !== -1) {
        params.student_status = this.searchInfo.current_status;
      }
      if (this.searchInfo.teach_status !== -1) {
        params.grant_lesson_status = this.searchInfo.teach_status;
      }
      if (this.searchInfo.roll_call_time) {
        params.roll_call_start_time = this.searchInfo.roll_call_time[0];
        params.roll_call_end_time = this.searchInfo.roll_call_time[1];
      }
      if (this.searchInfo.admin_time) {
        params.admission_start_time = this.searchInfo.admin_time[0];
        params.admission_end_time = this.searchInfo.admin_time[1];
      }
      if (this.searchInfo.sort_type) {
        params.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        params.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.course_id) {
        params.course_id = Number(this.searchInfo.course_id);
      }
      if (this.searchInfo.student_status > -1) {
        params.student_status = Number(this.searchInfo.student_status);
      }
      if (this.searchInfo.stop_type.length > 0) {
        params.stop_status = this.searchInfo.stop_type;
      }
      if (
        this.searchInfo.subject_ids &&
        this.searchInfo.subject_ids.length > 0
      ) {
        params.subject_ids = this.searchInfo.subject_ids;
      }
      if (this.searchInfo.course_type > -1) {
        params.course_type = this.searchInfo.course_type;
      }
      if (search_type === 1) {
        relationStudentListApi(params).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
        relationStudentListStatisticsApi(params).then((res) => {
          if (res.error_code === 0) {
            this.classTotal = res.data;
          }
        });
      } else {
        relationStudentListApi(params).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
      }
    },
    handleSearch() {
      this.getList(
        {
          page: 1,
          page_size: 10,
          teacher_id: Number(this.searchInfo.teacher_id),
        },
        1
      );
      this.mixinSavePageInfo("teacherAndStudentInfo");
    },
    handleTeacherChange() {
      const id = Number(this.searchInfo.teacher_id);
      if (id) {
        relationStudentStatisticsApi({
          teacher_id: id,
        }).then((res) => {
          if (res.error_code === 0) {
            this.teacherInfo = res.data;
            this.page = 1;
            this.pageSize = 10;
            this.getList(
              {
                teacher_id: Number(this.searchInfo.teacher_id),
              },
              1
            );
          }
        });
      }
      this.mixinSavePageInfo("teacherAndStudentInfo");
    },
    clickSort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList(
        {
          page: 1,
          page_size: this.pageSize,
          teacher_id: Number(this.searchInfo.teacher_id),
        },
        2
      );
    },
    goStudentDetail(sid) {
      this.$router.push({
        name: "studyDetails",
        query: {
          id: sid,
        },
      });
      this.mixinSavePageInfo("teacherAndStudentInfo");
    },
    goRollCallStudent(route_name, time, route_type) {
      if (route_name === "rollCallRecord") {
        localStorage.setItem(
          "teacher-and-student-to-rollcall-student-list",
          JSON.stringify([
            {
              teacher_id: this.searchInfo.teacher_id,
              teahcer_name: this.teacherInfo.teacher.name,
              name: this.teacherInfo.teacher.name,
            },
          ])
        );
      }
      if (time === "week") {
        const newPage = this.$router.resolve({
          name: route_name,
          query: {
            name: time,
            tid: this.searchInfo.teacher_id,
            s_time: this.startWeekTime,
            e_time: this.endWeekTime,
            route_type: route_type,
          },
        });
        window.open(newPage.href, "_blank");
      }
      if (time === "month") {
        const newPage = this.$router.resolve({
          name: route_name,
          query: {
            name: time,
            tid: this.searchInfo.teacher_id,
            s_time: this.startMonthTime,
            e_time: this.endMonthTime,
            route_type: route_type,
          },
        });
        window.open(newPage.href, "_blank");
      }
      if (time === "all") {
        const newPage = this.$router.resolve({
          name: route_name,
          query: {
            name: time,
            tid: this.searchInfo.teacher_id,
            route_type: route_type,
          },
        });
        window.open(newPage.href, "_blank");
      }
    },
    jumpRollCallStudent(route_name, route_type, s_n, course_id) {
      const newPage = this.$router.resolve({
        name: route_name,
        query: {
          tid: this.searchInfo.teacher_id,
          route_type: route_type,
          ts_n: s_n,
          course_id: course_id,
        },
      });
      window.open(newPage.href, "_blank");
    },
    Jumps(route_name, class_people) {
      if (class_people === "2" || class_people === "1") {
        const newPage = this.$router.resolve({
          name: route_name,
          query: {
            t_s_id: this.searchInfo.teacher_id,
            cl_pe: class_people,
          },
        });
        window.open(newPage.href, "_blank");
        return;
      }
      const newPage = this.$router.resolve({
        name: route_name,
        query: {
          t_s_id: this.searchInfo.teacher_id,
        },
      });
      window.open(newPage.href, "_blank");
    },
    handleClickDetail(row) {
      this.detailInfo = {
        student: row.student.name,
        course: row.course.detail.title,
      };
    },
    handleDetailChange() {
      this.getList(
        {
          page: this.page,
          page_size: this.pageSize,
          teacher_id: Number(this.searchInfo.teacher_id),
        },
        2
      );
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList(
        {
          page: e,
          page_size: this.pageSize,
          teacher_id: Number(this.searchInfo.teacher_id),
        },
        2
      );
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      // this.page = 1;
      this.getList(
        {
          page: 1,
          page_size: e,
          teacher_id: Number(this.searchInfo.teacher_id),
        },
        2
      );
    },
    relationSuccess() {
      this.getList(
        {
          page: 1,
          page_size: 10,
          teacher_id: Number(this.searchInfo.teacher_id),
        },
        1
      );
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
  .content {
    box-sizing: border-box;
    display: flex;
    .content-left {
      width: 221px;
      min-height: 502px;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      .content-left-top {
        height: 50px;
        background: #f2f6fa;
        display: flex;
        justify-content: center;
        align-items: center;
        /deep/ .content-left-top-in {
          .el-form-item {
            margin-bottom: 0;
            .el-form-item__content {
              width: 129px;
            }
          }
        }
      }
      .content-left-center {
        min-height: 78px;
        display: flex;
        padding: 15px 15px;
        box-sizing: border-box;
        .content-left-center-left {
          width: 50px;
          height: 50px;
          // background-color: red;
          border-radius: 50%;
          overflow: hidden;
        }
        .content-left-center-right {
          margin-left: 10px;
          .content-name {
            font-size: 16px;
            font-weight: 500;
          }
          .content-phone {
            display: flex;
            align-items: center;
            margin-top: 14px;
            font-size: 16px;
            font-weight: 400;
          }
        }
      }
      .xian {
        margin: 0 auto;
        width: 192px;
        border-bottom: 1px dashed #e7e8ea;
      }
      .teacher-detial {
        .left-info {
          .p1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 8px;
            margin-top: 15px;
            .left-info-title {
              font-size: 16px;
              font-weight: 500;
            }
          }
          .content-teacher-info {
            padding: 0 15px;
            .teacher-info-class {
              margin-top: 15px;
              display: flex;
              justify-content: space-between;
              cursor: pointer;
              .class-info-name {
                font-size: 14px;
                color: #5c5d5e;
                font-family: PingFangSC, PingFangSC-Regular;
              }
              .class-info-number {
                font-size: 14px;
              }
              .last-info {
                margin-bottom: 15px;
              }
            }
          }
        }
      }
    }
    .content-right {
      flex: 1;
      overflow: hidden;
      margin-left: 25px;
      /deep/.el-form {
        .el-form-item {
          display: flex;
          .el-form-item__label {
            min-width: 70px;
            text-align: right;
          }
          .el-form-item__content {
            width: 100%;
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .statistics {
    height: 28px;
    background: #fff7e9;
    border-radius: 4px;
    line-height: 28px;
    padding-left: 18px;
    color: #5c5d5e;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .curp {
    cursor: pointer;
  }
}
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.operation {
  display: flex;
  .operation-first {
    margin-right: 5px;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
</style>
